import { makeRequest } from 'utils/requestLogger';

export default () => makeRequest('post', '/api/users/cancel-subscription');



// WEBPACK FOOTER //
// ./src/app/services/account/cancelSubscription.js